import { render, staticRenderFns } from "./checkbox-terms.vue?vue&type=template&id=653bc16c"
import script from "./checkbox-terms.vue?vue&type=script&lang=js"
export * from "./checkbox-terms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports